import { render, staticRenderFns } from "./RosterHand.vue?vue&type=template&id=1935b2c6"
import script from "./RosterHand.vue?vue&type=script&lang=js"
export * from "./RosterHand.vue?vue&type=script&lang=js"
import style0 from "./RosterHand.vue?vue&type=style&index=0&id=1935b2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports